import { EUserAccountStatus } from '../enums/status.enum';
import { IStatusDescription } from '../interfaces/status-description.interface';
import { OptionDescription } from './option.type';

export type StatusRecord<T extends string | number | symbol> = Record<T, IStatusDescription>;
export type UserAccountStatusOption = OptionDescription<EUserAccountStatus> & { viewClass: string };
export type UserAccountStatusRecord = Record<EUserAccountStatus, UserAccountStatusOption>;
